import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './contact-tile2-country-indiv-stack.component.scss';
var ContactTile2CountryIndivStack = /** @class */ (function (_super) {
    tslib_1.__extends(ContactTile2CountryIndivStack, _super);
    function ContactTile2CountryIndivStack(element) {
        return _super.call(this, element) || this;
    }
    ContactTile2CountryIndivStack.prototype.init = function () { };
    ContactTile2CountryIndivStack.prototype.bindEvents = function () { };
    return ContactTile2CountryIndivStack;
}(Base));
export { ContactTile2CountryIndivStack };



//////////////////
// WEBPACK FOOTER
// ./components/contact-tile2-country-indiv-stack/contact-tile2-country-indiv-stack.component.ts
// module id = 210
// module chunks = 0